import { Wrench, Settings, CheckCircle } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: Wrench,
    title: "Get a Free Estimate",
    description:
      "Tell us about your lawn care, landscaping, or snow removal needs. We'll provide a clear, upfront estimate.",
  },
  {
    number: "02",
    icon: Settings,
    title: "Expert Service",
    description:
      "Our skilled crew completes your project with precision and professional-grade equipment.",
  },
  {
    number: "03",
    icon: CheckCircle,
    title: "Enjoy Your Property",
    description:
      "We clean up thoroughly and leave your property looking its absolute best.",
  },
];

export const Process = () => {
  return (
    <section className="py-20" aria-labelledby="process-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="section-badge">What to Expect</span>
          <h2 id="process-heading" className="text-3xl md:text-4xl font-heading font-bold text-foreground mt-4">
            Easy 3-step service process
          </h2>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-8" role="list">
          {steps.map((step, index) => (
            <li key={index} className="text-center relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-12 left-[60%] w-full h-0.5 border-t-2 border-dashed border-border" aria-hidden="true" />
              )}
              
              <div className="relative inline-block mb-6">
                <div className="process-circle" aria-hidden="true">
                  <step.icon className="w-10 h-10 text-secondary" />
                </div>
                <div className="process-number" aria-hidden="true">{step.number}</div>
              </div>
              
              <h3 className="text-xl font-heading font-bold text-foreground mb-3">
                <span className="sr-only">Step {step.number}: </span>{step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
